import './style.css';
import { Game } from './game';

const app = document.getElementById('app')!;
app.style.position = 'relative';

// Boot the game: lobby first, WebSocket connects immediately for room lists.
new Game(app);
